<template>
  <div class="box">
    <header-child ref="header" />
    <breadcrumb-child :title="'Системные/уведомления'" :name="'сведения'" :href="'/personalCenter'" />
    <div class="content">
      <div class="article">
        <p class="title">{{ message.title }}</p>
        <p class="data">{{ getTime(message.create_time) }}</p>
        <p class="line"></p>
        <p class="contents" v-html="message.content"></p>
      </div>
    </div>
  </div>
</template>

<script>
import headerChild from '../../components/Header';
import breadcrumbChild from '../../components/Breadcrumb';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { headerChild, breadcrumbChild },
  data() {
    //数据
    return { message: {} };
  },
  //计算属性
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // this.id = this.$route.params.id;
    this.messageDetails();
  },
  //方法集合
  methods: {
    messageDetails() {
      let data = {
        token: localStorage.getItem('token'),
        id: this.$route.params.id,
      };
      this.api.noticeInfo(data).then((res) => {
        // console.log(res);
        this.message = res.data;
      });
    },
    getTime(nS) {
      var date = new Date(parseInt(nS) * 1000);
      var year = date.getFullYear();
      var mon = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minu = date.getMinutes();
      var sec = date.getSeconds();
      return year + '-' + mon + '-' + day + ' ' + hours + ':' + minu + ':' + sec;
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  //生命周期 - 创建之前
  beforeCreate() {},
  //生命周期 - 挂载之前
  beforeMount() {},
  //生命周期 - 更新之前
  beforeUpdate() {},
  //生命周期 - 更新之后
  updated() {},
  //生命周期 - 销毁之前
  beforeDestroy() {},
  //生命周期 - 销毁完成
  destroyed() {},
  //如果页面有keep-alive缓存功能，这个函数会触发
  activated() {},
};
</script>
<style lang="less" scoped>
//@import url(); 引入公共css类
.box {
  .content {
    width: 100%;
    min-height: 100vh;
    padding-bottom: 20px;
    background: #f6f6f6;
    opacity: 1;
    .article {
      width: 1200px;
      min-height: 802px;
      background: #ffffff;
      opacity: 1;
      margin: 0 auto;
      padding: 30px 200px 30px 200px;
      .title {
        // height: 21px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 21px;
        color: #333333;
        opacity: 1;
        text-align: center;
        margin-bottom: 6px;
      }
      .data {
        text-align: center;
        height: 16px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 16px;
        color: #999999;
        opacity: 1;
      }
      .line {
        width: 100%;
        border-bottom: 1px solid #e6e6e6;
        margin: 12px 0 16px 0;
      }
      .contents {
        width: 800px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 24px;
        color: #666666;
        opacity: 1;
      }
    }
  }
}
</style>
